<template>
  <b-modal v-model="isShow" centered title="Xác nhận huỷ" no-close-on-backdrop>
    <h6><span class="text-danger">*</span> Lý do huỷ công việc:</h6>
    <b-form-input v-model="note" placeholder="Nhập lý do huỷ" />

    <template #modal-footer>
      <div class="d-flex justify-content-end">
        <b-button variant="danger" :disabled="isLoading || !note.trim()" @click="confirmCancel">
          Xác nhận
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
  import { TaskUpdateCalcel } from '@/services/customer-support/task'
  import { showMess } from '@/config/utils'

  export default {
    name: 'ShowImage',
    components: {
      // UpdateAFS,
    },
    data() {
      return {
        isShow: false,
        isLoading: false,
        note: '',
        info: {},
      }
    },

    methods: {
      show(info) {
        this.isShow = true
        this.info = info
        this.note = ''
      },

      close() {
        this.isShow = false
      },

      async confirmCancel() {
        try {
          this.isLoading = true
          const res = await TaskUpdateCalcel(this.info.id, {
            note: this.note,
          })
          if (res.code === 1000) {
            this.$emit('change')
            this.isShow = false
          } else {
            showMess(this, 'Thông báo', res.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
          }
        } catch (e) {
          showMess(
            this,
            'Thông báo',
            e.response?.data?.message || e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        } finally {
          this.isLoading = false
        }
      },
    },
  }
</script>

<style scoped></style>
